import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import { getCurrency } from '@utils/tools/currencyTools';
import { IMonthlyPaymentSectionProps, IPaymentItem } from '../../types';
import { getRowClassName, isValidAmount } from '../../utils';

// ============================================================================
// Sub-Components
// ============================================================================

const PaymentRow: React.FC<IPaymentItem> = ({ labelId, value, isTotal = false, dataTestId }) => (
    <ConditionalRendering isTrue={isValidAmount(value)}>
        <div className={getRowClassName(isTotal)} data-testid={dataTestId}>
            <span className="text-base-dark"><FormattedMessage id={labelId} /></span>
            <span className="text-base-dark">{getCurrency(Number(value))}</span>
        </div>
    </ConditionalRendering>
);

// ============================================================================
// Component
// ============================================================================

const MonthlyPaymentSection: React.FC<IMonthlyPaymentSectionProps> = ({ 
    id,
    paymentItems = [],
    titleLabelId = '',
}) => {
    return (
        <div id={id} data-testid={id ? `monthly-payment-${id}` : ''}>
            <h4 className="text-uppercase margin-top-0 margin-bottom-2">
                <FormattedMessage id={titleLabelId} />
            </h4>
            {paymentItems.map((item, index) => (
                <PaymentRow key={`${item.labelId}-${index}`} {...item} />
            ))}
        </div>
    );
};

export default MonthlyPaymentSection;
